import { gql } from '@apollo/client'

export const PROCESS_BACKGROUND_REMOVAL = gql`
  mutation ProcessBackgroundRemoval($participantId: ID!) {
    processBackgroundRemoval(participantId: $participantId) {
      id
      image
      imageWithBackground
    }
  }
`
